import { appendScSources } from '../sc-product-selector/sc-product-selector';
import { CR, HPC } from '../types';
class Selector {
  constructor() {
    this.inited = false;
  }
  async init(config) {
    if (!this.inited) {
      await appendScSources(document.body, config.scConfiguratorUrlJS, config.scConfiguratorUrlCSS);
      this.inited = true;
    }
    return this;
  }
  open(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (this.inited) {
      if (this.widget) {
        this.widget.destroy();
      }
      let dataset;
      if (config.type === HPC) {
        dataset = {
          type: config.type,
          value: {
            product_cr: config.productCR,
          },
        };
      }
      if (config.type === CR) {
        dataset = {
          type: config.type,
          value: config.productCR,
        };
      }
      if (config.enableCrossTechAPI || (dataset === null || dataset === void 0 ? void 0 : dataset.type) === HPC) {
        this.widget = window.seWidgetWrapper.startWidget(dataset, (_a = config.language) !== null && _a !== void 0 ? _a : '', (_b = config.country) !== null && _b !== void 0 ? _b : '', (_c = config.project) !== null && _c !== void 0 ? _c : '', (_d = config.token) !== null && _d !== void 0 ? _d : '', config.options || {});
      }
      else {
        this.widget = window.seWidgetWrapper.loadConfigModelByCoreReference(config.productCR, (_e = config.language) !== null && _e !== void 0 ? _e : '', (_f = config.country) !== null && _f !== void 0 ? _f : '', (_g = config.project) !== null && _g !== void 0 ? _g : '', (_h = config.token) !== null && _h !== void 0 ? _h : '', (_j = config.options) !== null && _j !== void 0 ? _j : {});
      }
      this.widget.addSaveConfigurationListener((rest) => {
        document.dispatchEvent(new CustomEvent('scSelectorAddToCart', { detail: rest }));
      });
    }
    else {
      console.error("Can't open widget, selector is not inited");
    }
    return this;
  }
}
export const HpcProductSelector = new Selector();
